// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfigListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetToolConfigsForPhoneNumber(): (
  phoneNumberId: string,
  toolId: string
) => Promise<ToolConfigListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (phoneNumberId, toolId) =>
      (await getAPI()).phonenumbers.getToolConfigsForPhoneNumber({
        phoneNumberId,
        toolId,
      }),
    [getAPI]
  );
}
